/* istanbul ignore file */

import { getPadraoComRetorno, postPadraoComRetorno, putPadraoComRetorno } from 'services/api';
import { montarUrlFiltro } from 'utils/funcaoPadrao';
import { duckTodosServicosListar, duckServicoDetalhar } from 'store/ducks/servico';
import { duckInputSelectOptionsServicos } from 'store/ducks/inputs';
import { ID_SERVICO_DETALHAR, FORMULARIOS } from 'utils/consts';
import { servicosSistemaDetalhar } from 'routes/paths';

export const fetchGetTodosServicos = (listaSolicitacoes = []) => dispatch => {
  return new Promise((resolve, reject) => {
    if (listaSolicitacoes?.length > 0) {
      resolve(listaSolicitacoes);
    } else {
      const url = `Solicitacao/GetAllByAssuntoId/${FORMULARIOS.SERVICOS.id}`;
      dispatch(getPadraoComRetorno(url))
        .then(res => {
          dispatch(duckInputSelectOptionsServicos(res));
          resolve(res);
        })
        .catch(erro => reject(erro));
    }
  });
};

export const fetchSalvarNovoServico = servico => dispatch => {
  return new Promise(resolve => {
    const url = `Solicitacao/InserirServico`;
    dispatch(postPadraoComRetorno(url, servico)).then(res => resolve(res));
  });
};

export const fetchSalvarServicoEditado = servico => dispatch => {
  return new Promise(resolve => {
    const url = `Solicitacao`;
    dispatch(putPadraoComRetorno(url, servico)).then(res => resolve(res));
  });
};

export const fetchGetServicosByFilter = (filtro, page, itemsByPage) => dispatch => {
  const url = montarUrlFiltro(`Solicitacao/page=${page}&itemsByPage=${itemsByPage}`, filtro);
  dispatch(duckTodosServicosListar({ list: [] }));
  dispatch(getPadraoComRetorno(url, true)).then(res => {
    dispatch(duckTodosServicosListar(res));
  });
};

export const fetchDetalharServicoPorId = (id, history) => dispatch => {
  const url = `Solicitacao/${id}`;
  dispatch(getPadraoComRetorno(url)).then(retorno => {
    dispatch(duckServicoDetalhar(retorno));
    localStorage.setItem(ID_SERVICO_DETALHAR, id);
    history.push(servicosSistemaDetalhar);
  });
};
